var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field-recaptcha"},[_c('div',{staticClass:"grecaptcha-note"},[_c('span',{domProps:{"innerHTML":_vm._s(
                _vm.$t(_vm.recaptchaNote, {
                    privacyPolicyLink: 'https://policies.google.com/privacy',
                    termsOfServiceLink: 'https://policies.google.com/terms',
                })
            )}})])])}
var staticRenderFns = []

export { render, staticRenderFns }